export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy } from 'utils/fetchRequest';

export const getFeedback = async (searchText) => {
    try {
        const result = await get(`feedback${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createFeedback = async (data) => {
    try {
        const result = await post('feedback', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};





